import Cucco from "../../../core/assets/oot/gshd/chicken_32x32.png";
import WeirdEgg from "../../../core/assets/oot/gshd/egg_32x32.png";
import KeatonMask from "../../../core/assets/oot/gshd/keaton-mask_32x32.png";
import MaskOfTruth from "../../../core/assets/oot/gshd/mask-of-truth_32x32.png";
import SkullMask from "../../../core/assets/oot/gshd/skull-mask_32x32.png";
import SpookyMask from "../../../core/assets/oot/gshd/spooky-mask_32x32.png";
import ZeldaLetter from "../../../core/assets/oot/gshd/zeldas-letter_32x32.png";
import BunnyHood from "../../../core/assets/oot/gshd/bunny-hood_32x32.png";
import UpgradeItem from "../../../core/items/UpgradeItem";
import OotItem from "./OotItem";
import { SimpleItemProps } from "./SimpleItemProps";
import StaticItem from "../../../core/items/StaticItem";

const ChildSequenceItem = () => {

    let id = "OoT_ChildSequence"

    let sequence = [WeirdEgg, Cucco, ZeldaLetter, KeatonMask, SkullMask, SpookyMask, MaskOfTruth]


    return <OotItem id={id}>
        {({ updateOotItem, item }) => {
            return <UpgradeItem
                id={id}
                image={sequence}
                title={["Weird Egg", "Cucco", "Zelda's Letter", "Keaton Mask", "Skull Mask", "Spooky Mask", "Mask of Truth"]}
                upgradeLabel={["", "", "", "", "", "", ""]} updateItem={updateOotItem} item={item}
                isMajor
            />
        }}
    </OotItem>

}

export default ChildSequenceItem;

export const SimpleZeldaLetterItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={ZeldaLetter}
        onClick={props.onClick}
        name={"SimpleZeldaLetterItem"}
    />


}
export const SimpleKeatonMaskItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={KeatonMask}
        onClick={props.onClick}
        name={"SimpleKeatonMaskItem"}
    />


}

export const SimpleSkullMaskItem = (props: SimpleItemProps) => {


    return <StaticItem
        image={SkullMask}
        onClick={props.onClick}
        name={"SimpleSkullMaskItem"}
    />



}

export const SimpleSpookyMaskItem = (props: SimpleItemProps) => {

 return <StaticItem
        image={SpookyMask}
        onClick={props.onClick}
        name={"SimpleSpookyMaskItem"}
    />



}

export const SimpleMaskOfTruthItem= (props: SimpleItemProps) => {


     return <StaticItem
        image={MaskOfTruth}
        onClick={props.onClick}
        name={"SimpleMaskOfTruthItem"}
    />



}

export const SimpleBunnyHoodItem = (props: SimpleItemProps) => {


         return <StaticItem
        image={BunnyHood}
        onClick={props.onClick}
        name={"SimpleBunnyHoodItem"}
    />



}